import React from "react";
import { fetchWebhookLogEntryByID } from "../../utils/IntegrationsManagementAPIClient";
import { LogSidePanel } from "./shared-components/LogSidePanel";

const WebhookLogEntrySidePanel = () => {
  return <LogSidePanel title="Webhook Log" fetchLog={fetchWebhookLogEntryByID} />;
};

export default WebhookLogEntrySidePanel;
